


























































import Vue from 'vue'
import { Component, Watch } from 'vue-property-decorator'
import { ROUTER_NAME } from '../../router'
import Course from '../../../api/v2/models/course'
import api from '../../../api/v2/api'
import CourseButton from '../organisms/CourseButton.vue'
import { headerState } from '../../stores/header'
import { userState } from '../../stores/user'

@Component({
  components: {
    CourseButton
  }
})
export default class CourseDetail extends Vue {
  mobile: boolean = false
  course: Course = null
  isMobile: boolean = false

  get user(){
    return userState.user
  }

  get breadcrumbs() {
    if (this.$route.params.userGoalId) {
      return [
        {
          text: 'ゴール一覧',
          disabled: false,
          exact: true,
          to: `/classroom/user-goals`
        },
        {
          text: 'ゴール詳細',
          disabled: false,
          exact: true,
          to: `/classroom/user-goals/${this.$route.params.userGoalId}`
        },
        {
          text: this.course ? this.course.name : '',
          disabled: true,
          exact: true,
        }
      ]
    }

    return [
      {
        text: 'コース一覧',
        disabled: false,
        exact: true,
        to: '/classroom/courses'
      },
      {
        text: this.course ? this.course.name : '',
        disabled: true
      }
    ]
  }

  created() {
    this.getCourse()
  }

  mounted() {
    this.onResize()
    window.addEventListener('resize', this.onResize)
  }

  async getCourse() {
    try {
      this.course = await api.course.show(this.$route.params.courseId)
      headerState.setTitle(this.course.name)

      // レッスン指定される場合、直接のenrrllmentに移動する
      if (this.$route.query.lesson_id) {
        api.enrollment.show({
          user_id: this.user.id,
          course_id: this.course.id
        }).then(enrollment => {
          if (enrollment && enrollment.id) {
            this.$router.push(`/classroom/my-courses/${this.$route.params.courseId}?lesson_id=${this.$route.query.lesson_id}`)
          }
        })
      }

    } catch(e) {
    }
  }

  beforeDestroy() {
    if (typeof window !== 'undefined') {
      window.removeEventListener('resize', this.onResize)
    }
  }

  onResize() {
    this.isMobile = window.innerWidth < 600
  }

  @Watch('$route')
  changeRoute(val, oldVal) {
    this.getCourse()
  }
}
